/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Generate_ReportInputs */

const en_audit_generate_report = /** @type {(inputs: Audit_Generate_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Report`)
};

const es_audit_generate_report = /** @type {(inputs: Audit_Generate_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar Reporte`)
};

/**
* | output |
* | --- |
* | "Generate Report" |
*
* @param {Audit_Generate_ReportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_generate_report = /** @type {((inputs?: Audit_Generate_ReportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Generate_ReportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_generate_report(inputs)
	return es_audit_generate_report(inputs)
});